import { Box, Button, Flex, IconArrowRight, Image, Text } from '@cmpsr/components';
import { FC } from 'react';
import { DECISION_TREE_CTA_TEST_ID } from '../../../../constants';
import { DumbSectionDividerProps } from './types';

export const SectionDividerDesktop: FC<DumbSectionDividerProps> = ({
  title,
  text,
  orderNumber,
  isLoading,
  handleNextClick,
  imageId,
  navbarHeight,
}) => {
  return (
    <Flex
      alignItems="center"
      maxHeight={`calc(100svh - ${navbarHeight}px)`}
      overflow="hidden"
      background="gradient-01"
      flexGrow={1}
    >
      <Image
        srcSet={`/images/interstitials/${imageId}/${imageId}-400w.avif 400w, /images/interstitials/${imageId}/${imageId}-600w.avif 600w, /images/interstitials/${imageId}/${imageId}-800w.avif 800w, /images/interstitials/${imageId}/${imageId}-1000w.avif 1000w, /images/interstitials/${imageId}/${imageId}-1200w.avif 1200w, /images/interstitials/${imageId}/${imageId}-1600w.avif 1600w, /images/interstitials/${imageId}/${imageId}-2000w.avif 2000w`}
        sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
        src={`/images/interstitials/${imageId}/${imageId}-400w.avif`}
        alt={title}
        flexBasis="50%"
        w="50%"
        alignSelf="center"
        objectFit="cover"
        objectPosition="center"
        height={`calc(100vh - ${navbarHeight}px)`}
      />
      <Box flexShrink={0} py="22" px={{ base: '22', xl: '24', xxl: '32' }} flexBasis="50%" textAlign="left">
        <Text
          variant="text-body-regular"
          mb="6"
          textTransform="uppercase"
          fontFamily="Inter"
          color="text-link-secondary-default"
        >
          Section {String(orderNumber)}
        </Text>
        <Text
          variant="text-header-XL"
          mb={{ base: '0', lg: '3' }}
          textStyle="text-header-xl-v"
          color="text-primary-negative"
        >
          {title}
        </Text>
        <Text variant="text-body-meta-regular" mb="8" color="text-primary-negative">
          {text}
        </Text>
        <Button
          onClick={handleNextClick}
          variant="accent"
          size={{ base: 's', md: 'm' }}
          trailingIcon={<IconArrowRight />}
          isDisabled={isLoading}
          isLoading={isLoading}
          width={{ base: '100%', md: '200px' }}
          borderRadius={{ base: 0, md: 'radii-button' }}
          px="7 !important"
          py="3 !important"
          data-testid={DECISION_TREE_CTA_TEST_ID}
        >
          Let's Go
        </Button>
      </Box>
    </Flex>
  );
};
